import { usePrecandidateContext } from "../context/Context";
import EditPrecandidate from "./EditPrecandidate";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { useTranslation } from "react-i18next";
import "./stylesEdit.scss";

const ModalEditPrecandidate = ({ title }) => {
  const {
    modalEditShow,
    setModalEditShow,
    onCloseForm,
    UpdatePreCandidate
  } = usePrecandidateContext();
  const handleCloseEdit = () => {
    setModalEditShow(false);
    onCloseForm();
  };
  const { t } = useTranslation();

  return (
    <ModalContainer
      modalTitle={title}
      closeModal={handleCloseEdit}
      isOpen={modalEditShow}
      cancelButtonAction={handleCloseEdit}
      cancelButtonTitle={t("Cancel")}
      submitButtonAction={UpdatePreCandidate}
      submitButtonTitle={t("Done")}
      submitButtonType="submit"
      modalSize="xl"
    >
      <EditPrecandidate />
    </ModalContainer>
  );
};

export default ModalEditPrecandidate;
